<template>
  <AppLink
    v-if="to"
    :to="to"
    :class="button_classes"
  >
    <FontAwesomeIcon
      :icon="icon_fontawesome"
      class="text-sm"
    />
  </AppLink>
  <button
    v-else
    type="button"
    :disabled="is_disabled || null"
    :aria-pressed="is_toggle ? is_active : null"
    :class="button_classes"
    @click.stop="submit"
  >
    <FontAwesomeIcon
      :icon="icon_fontawesome"
      class="text-sm"
    />
  </button>
</template>

<script setup>
import { computed } from 'vue';
import BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON from '@/app/data/button_constants';
import { STATUS, STATUS_COLORS } from '@/app/data/status_constants';
import AppLink from '@/app/shared_components/AppLink.vue';

defineOptions({
  name: 'ButtonCircle',
});

const props = defineProps({
  action: {
    type: String,
    required: true,
    validator: (prop) => Object.keys(BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON).includes(prop),
  },
  status: {
    type: String,
    default: STATUS.PRIMARY,
    validator: (prop) => Object.keys(STATUS_COLORS).includes(prop),
  },
  is_active: { type: Boolean, default: false },
  is_disabled: { type: Boolean, default: false },
  is_subtle: { type: Boolean, default: false },
  is_toggle: { type: Boolean, default: false },
  to: { type: Object, default: null },
});

const emit = defineEmits(['onClick']);

const icon_fontawesome = computed(() => BUTTON_CIRCLE_ACTIONS_TO_FONTAWESOME_ICON[props.action]);

const button_classes = computed(() => {
  const active_colors = STATUS_COLORS[props.status];
  const classes = [
    'flex size-9 shrink-0 items-center justify-center rounded-full border transition-all duration-200',
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
  ];

  if (props.is_subtle) {
    classes.push('border-transparent bg-transparent text-surface-400 hover:text-surface-600');
  } else if (props.is_active) {
    classes.push(`${active_colors.TAG_BG} ${active_colors.TAG_TEXT} ${active_colors.TAG_BORDER} shadow-sm`);
  } else {
    classes.push(
      'border-surface-200 bg-white text-surface-500 hover:border-surface-300 hover:bg-surface-100 hover:text-surface-700',
    );
  }

  classes.push(props.is_disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer');
  return classes;
});

function submit(event) {
  if (props.is_disabled) return;
  emit('onClick', event);
}
</script>
